<template>
  <div
    v-if="show"
    class="item"
  >
    <span class="title">
      {{ title }}:
    </span>
    <span class="value">
      {{ output }}
    </span>
    <br>
  </div>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { FieldTypes, VisNode } from '@/types'

const props = {
  item: {
    type: String,
    required: true,
  },
  node: {
    type: Object as PropType<VisNode>,
    required: true,
  },
}

@Component
export default class CategoryItem extends Vue.extend({ props }) {
  get fieldValueForColumn () {
    return this.$typedStore.visualisationData.fieldValueForColumn
  }

  get formatValueByColumn () {
    return this.$typedStore.visualisationData.formatValueByColumn
  }

  get name () {
    return this.$typedStore.visualisationApp.name
  }

  get field () {
    return this.$typedStore.visualisationApp.field(this.item)
  }

  get title () {
    return this.name(this.item)
  }

  get valueString () {
    if (this.item in this.node.data) return this.node.data[this.item]
  }

  get valueNumeric () {
    return this.fieldValueForColumn(this.item, [this.node])
  }

  get formattedNumeric () {
    return this.formatValueByColumn(this.item, +this.valueNumeric)
  }

  get output () {
    return this.field?.type === FieldTypes.STRING ? this.valueString : this.formattedNumeric
  }

  get show () {
    return this.field && !!this.output
  }
}

</script>

<style scoped>

.item {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.title {
  font-weight: bold;
}

</style>
